import Content from "./components/Content"
import Hero from "./components/Hero"
import Schedule from "./components/Schedule"
const PirateAdventure = () => {
  return (
    <div>
        <Hero/>   
        <Schedule /> 
        <Content />    
    </div>
  )
}

export default PirateAdventure